module.exports = __webpack_public_path__ + "static/media/popin_logo_white.782b3836.svg";